export default class tagSelectWithNegative {
    constructor() {
        return {
            restrict: 'A',
            scope: {
               load: '=',
               target: '@'
            },
            controller: ['$scope', '$timeout', '$element', 'Tag', ($scope, $timeout, $element, Tag) => {
                const target = $scope.target || '_self';
                $timeout(() => {
                    let tagSelect = $($element).selectize({
                        valueField: 'id',
                        labelField: 'name',
                        searchField: 'name',
                        plugins: ['remove_button'],
                        preload: true,
                        create: false,

                        render: {
                            item: (data, escape) => {
                                let item;
                                let name = escape(data.name);

                                // Remove negative tags from options drop-down
                                if (data.name.charAt(0) === '-') {
                                    let options = tagSelect[0].selectize.options;
                                    let items = tagSelect[0].selectize.items;

                                    angular.forEach(options, (tag) => {
                                        if (tag.name.charAt(0) === '-' && items.indexOf(tag.id) === -1) {
                                            tagSelect[0].selectize.removeOption(tag.id);
                                        }
                                    });

                                    item = `<div data-value="${data.id}" class="item tag-label negative">
                                                <a style="color:inherit;" href="#/tag/${Math.abs(data.id)}" target="${target}">
                                                    ${name}
                                                </a>
                                            </div>`;
                                } else {
                                    if (data.isShared) {
                                        item = `<div data-value="${data.id}" class="item tag-label">
                                                    <a style="color:inherit;" href="#/tag/${Math.abs(data.id)}" target="${target}">
                                                        ${name}
                                                    </a>
                                                    <span class="line-icon line-icon-share tag-select-shared-icon"></span>
                                                </div>`;
                                    } else {
                                        item = `<div data-value="${data.id}" class="item tag-label">
                                                    <a style="color:inherit;" href="#/tag/${Math.abs(data.id)}" target="${target}">
                                                        ${name}
                                                    </a>
                                                </div>`;
                                    }
                                }

                                return item;
                            }
                        },

                        load: (query, callback) => {
                            let isNegative = false;

                            if (!query.length) {
                                return Tag.all().then((tags) => {
                                    callback(tags.data);
                                })
                            }

                            if (query.charAt(0) === '-') {
                                isNegative = true;
                                query = query.slice(1);
                            }

                            if (query.length > 0) {
                                Tag.findByName(query).then((result) => {
                                    const tags = result.data

                                    angular.forEach(tags, (tag) => {
                                        if (isNegative) {
                                            tags.push({
                                                name: '-' + tag.name,
                                                id: '-' + tag.id
                                            });
                                        }
                                    });

                                    callback(tags);
                                });
                            }
                        }
                    });

                    var unregisterLoadedTags = $scope.$watch('load', (newVal) => {
                        if (newVal !== false) {
                            angular.forEach(newVal, (tag) => {
                                if (tag.pivot.negative == true) {
                                    tag.id = '-' + tag.id;
                                    tag.name = '-' + tag.name;
                                }

                                $timeout(() => {
                                    tagSelect[0].selectize.addOption({id: tag.id, name: tag.name});
                                    tagSelect[0].selectize.addItem(tag.id);
                                })
                            });

                            unregisterLoadedTags();
                        }
                    })
                });
            }]
        }
    }
};
